import $ from 'jquery'
import MessageView from './view/message-view'
import Model from './model/message'

class Message {
    constructor () {
        this.MessageView = MessageView
        this.Model = Model
    }

    closeAll () {
        $('.box-message').remove()
    }

    // message: "Sua mensagem foi enviada com sucesso.",
    // type: "alert-success",
    create (data) {
        return new MessageView({
            className: 'message__item',
            tagName: 'div',
            model: new Model(data)
        })
    }
}

window.GPAbstractModules = window.GPAbstractModules || {}
window.GPAbstractModules.Message = Message
